import CustomizedButton from "@/modules/ui-elements/CustomizedButton";
import { css } from "@emotion/react";
import { ICONS, Icon } from "@/modules/ui-elements/Icon";
import { useRouter } from "next/router";
import { EditorScreen } from "@/modules/batchEditor/BulkUploadEditor/constant";
import useBatchStore from "../../BulkUploadNewStore/BulkUploadStore";
import { aiTaskDisableAtom, batchEditorSelectedPresetAtom, sendForProTouchAtom } from "../../atoms";
import { useAtom, useSetAtom } from "jotai";

function SuccessScalePopup({ setSelectUpscaleValue }) {
  const router = useRouter();
  const {resetBulkUploadStore} = useBatchStore();
  const setSelectedPreset = useSetAtom(batchEditorSelectedPresetAtom);
  const setAiTaskDisable = useSetAtom(aiTaskDisableAtom);
  const setSendForProTouch = useSetAtom(sendForProTouchAtom);

  const closeHandler = (type:string) => async() => {
    setSelectUpscaleValue(false);
    if(type === "HOME"){
       router.push("/dashboard/homePage");
    }else{
    const newQuery = JSON.parse(JSON.stringify(router.query));
    delete newQuery.batchAI;
    setAiTaskDisable(false);
    setSendForProTouch(false);
    setSelectedPreset({marketplace_id:"64cb7e5423d9644b4cf689e2", name:"Amazon, eBay, Etsy, Walmart"});
      router.replace({
        query: { ...newQuery, mode: EditorScreen.UPLOAD},
     });
    }
    resetBulkUploadStore();
  };

  return (
    <div css={styles.container}>
      <div css={styles.popupBox}>
        <Icon src={ICONS.okGreen} width={32} height={32} />
        <div css={styles.messageStyle}>
        <h2>"Project submitted for upscaling images".</h2>
        <h2>We will send you an email when the images are upscaled.</h2>
        </div>
        <h2 css={styles.trackStyle} onClick={()=>router.push("/dashboard/my_projects?tab=COMPLETED")}>Track your Project in My Projects</h2>
        <CustomizedButton
          type="white_with_border"
          btnText={"Create Another"}
          btnStyle={styles.btnStyle1}
          isActive={true}
          onClick={closeHandler("HOME")}
        />
        <CustomizedButton
          type="white_with_border"
          btnText={"Home"}
          btnStyle={styles.btnStyle}
          isActive={true}
          onClick={closeHandler("HOME")}
        />
      </div>
    </div>
  );
}

const styles = {
  container: css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgb(0, 0, 0, 0.5);
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items:center;
  `,
  popupBox: css`
    border-radius: 8px;
    background: #fff;
    box-shadow: 0px 1px 32px 0px rgba(38, 38, 38, 0.08);
    height: 308px;
    width: 600px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `,
  crossBox: css`
    position: absolute;
    right: 10px;
    top: 10px;
    background: #eee;
    border-radius: 4px;
    padding: 10px;
    cursor: pointer;
  `,
  messageStyle:css`
   margin-top:24px;
   h2{
    color: #262626;
    text-align: center;
    font-family: Objectivity;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 180%; /* 25.2px */
    margin:0;
    padding:0;
   }
  `,
  trackStyle:css`
    color: #262626;
    text-align: center;
    font-family: Objectivity;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 18px */
    text-decoration-line: underline;
    margin:24px 0 40px 0px;
    padding:0;
    cursor:pointer;
  `,
  btnStyle:{
    display: "flex",
    height: "40px",
    padding: "9px 32px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: "0",
    fontWeight:"normal",
    fontSize: "12px",
    borderRadius: "4px",
    border: "1px solid #EEE",
    background: "#F9F9F9",
  },
  btnStyle1:{
    display: "flex",
    height: "40px",
    padding: "9px 32px",
    justifyContent: "center",
    fontSize: "12px",
    alignItems: "center",
    flexShrink: "0",
    fontWeight:"normal",
    borderRadius: "4px",
    marginBottom:"16px"
  },
};
export default SuccessScalePopup;
